import { MUIPrimitives } from "./../Views/MUIPrimitives";
import { coreTheme } from "./../../Core/Components/Styles/CoreStyling";
import { createMuiTheme, Theme, ThemeOptions } from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import { colors } from "@material-ui/core";
import { Palette } from "@material-ui/core/styles/createPalette";

//Define your custom breakpoints here or accept the default values which are the standard common breakpoints

export const breakpointTheme = createMuiTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 767,
            lg: 1024,
            xl: 1920,
        },
    },
});

//Add your specific app styling here
declare module "@material-ui/core" {
    export interface Theme {
        app: {
            colors: {
                success: {
                    dark: string;
                    light: string;
                };
            };
        };
    }
}

export const defaultTheme = createMuiTheme({
    typography: {
        fontFamily: ["Nexa Regular", "Montserrat", "Roboto Condensed", "Helvetica", "Arial", "sans-serif"].join(","),
        // h1 - used by product selector
        h1: {
            fontFamily: "Nexa Light",
            fontSize: "44px",
            fontWeight: "normal",
            lineHeight: "1.167",
        },
        // h2 - used by product selector
        h2: {
            fontFamily: "Nexa Bold",
            fontSize: "20.25px",
            fontWeight: "normal",
            lineHeight: "1.3",
        },
        h3: {
            fontFamily: "Nexa Bold",
            fontSize: "1.25rem",
            fontWeight: "normal",
        },
        // h4 - used by product selector
        h4: {
            fontFamily: "Nexa Bold",
            fontSize: "18.75px",
            fontWeight: "normal",
            lineHeight: "1.5",
        },
        h5: {
            fontSize: "0.83rem",
            fontWeight: "bold",
            [breakpointTheme.breakpoints.down("lg")]: {
                //fontSize: "0.55em",
            },
        },
        h6: {
            fontSize: "0.67rem",
            fontWeight: "bold",
            [breakpointTheme.breakpoints.down("lg")]: {
                //fontSize: "0.47em",
            },
        },
        subtitle1: {
            fontSize: "1rem",
            fontWeight: 300,
            //lineHeight: `${1.8 * referenceFontSize}vw`,
            letterSpacing: "-0.4px",
            [breakpointTheme.breakpoints.down("lg")]: {
                //fontSize: "1em",
                //lineHeight: `${1.8 * referenceFontSize}vw`,
                //letterSpacing: "-0.4px",
            },
        },
        subtitle2: {
            fontSize: "0.875rem",
            //fontWeight: 300,
            [breakpointTheme.breakpoints.down("lg")]: {
                // fontSize: "0.8em",
            },
        },
        body1: {
            fontSize: "1rem",
            //fontWeight: 300,
            [breakpointTheme.breakpoints.down("lg")]: {
                // fontSize: "0.8em",
            },
        },
        // body2 - used by product selector
        body2: {
            fontFamily: "Nexa",
            fontSize: "12px",
            lineHeight: "1.6",
        },
        button: {
            fontSize: "0.875rem",
            //fontWeight: 300,
            [breakpointTheme.breakpoints.down("lg")]: {
                // fontSize: "0.8em",
            },
        },
        caption: {
            fontSize: "0.75rem",
            //fontWeight: 300,
            [breakpointTheme.breakpoints.down("lg")]: {
                // fontSize: "0.8em",
            },
        },
        overline: {
            fontSize: "0.75rem",
            //fontWeight: 300,
            [breakpointTheme.breakpoints.down("lg")]: {
                // fontSize: "0.8em",
            },
        },
    },
    palette: {
        background: { paper: "#fff", default: "#fff" },
        primary: {
            main: "#000000",
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: "#c12631",
            contrastText: "#FFFFFF",
        },
    },
    overrides: {
        MuiFormControlLabel: {
            label: {
                fontFamily: "Nexa",
                fontSize: "14px",
            },
        },
        MuiFormLabel: {
            root: {
                fontFamily: "Nexa",
                fontSize: "14px",
            },
        },
        MuiInput: {
            root: {
                fontFamily: "Nexa",
                fontSize: "14px",
            },
        },
        MuiInputAdornment: {
            root: {
                fontFamily: "Nexa",
            },
        },
        MuiInputLabel: {
            root: {
                fontFamily: "Nexa",
                fontSize: "14px",
            },
        },
        MuiLink: {
            root: {
                fontSize: "14px",
            },
        },
    },
});
